module.exports = __webpack_public_path__ + "img/logo_birdlife_middle_east.ae3c41f5.jpg";